<app-card title="Cadastro de itens filhos">
    <div class="app-card-body">
        <form [formGroup]="composicaoForm">
            <div class="row">
                <app-combobox-produto style="margin-bottom: 0px;" [label]="'Produto'" (change)="itemChanged($event)"
                    class="form-group col-sm-6" formControlName="itemFilhoID" [filtroItensFilhos]="produtoID">
                </app-combobox-produto>
                <div class="form-group col-sm-6">
                    <label>Quantidade</label>
                    <input type="text" class="form-control" formControlName="quantidade" currencyMask inputmode="numeric" [options]="optionsQuantidade">
                    <app-ajuste-numerico [form]="composicaoForm" formControlName="quantidade"></app-ajuste-numerico>
                    <show-errors [control]="composicaoForm.controls.quantidade"></show-errors>
                </div>
            </div>
            <button class="btn btn-primary" (click)="salvarItem()"><i class="ti ti-save"></i> Salvar</button>
            <button class="btn btn-danger" (click)="cancelarDigitacao()"><i class="ti ti-close"></i> Cancelar</button>
        </form>
    </div>
</app-card>